import { Redirect } from '@reach/router';
import React, { Suspense } from 'react';
import { isLoggedIn } from '../../utils/auth';
import { Layout } from '../layout';

const PrivateRoute = (props) => {
  if (!isLoggedIn()) {
    return <Redirect to="/login" noThrow />;
  }
  const { children, component: Component, location, ...rest } = props;
  return (
    <Layout isUserNav>
      <Suspense fallback={<div>...Loading</div>}>
        <Component {...rest} />
      </Suspense>
    </Layout>
  );
};

export default PrivateRoute;
